import { useContentBundle } from '@/hooks/useContentBundle'

export function useSharedCustomViewsEnabled(): boolean {
  const { data: bundle } = useContentBundle()
  return bundle?.sharedCustomViewsEnabled === true
}
